import apiService from '../api/apiService';
import { Coupon } from '../types/couponTypes';
import { AxiosResponse } from 'axios';

const CouponController = {
    getMyCoupons: (page: number = 0, size: number = 10): Promise<AxiosResponse<Coupon[]>> => apiService.get<Coupon[]>('/coupons', { page, size }),
    getCoupon: (couponId: string): Promise<AxiosResponse<Coupon>> => apiService.get<Coupon>(`/coupons/${couponId}`),
    // Backend uses @ModelAttribute + has a MultipartFile field, so requests
    // must be multipart/form-data. Accept FormData here; the form constructs it.
    createCoupon: (data: FormData | Coupon): Promise<AxiosResponse<Coupon>> => apiService.post<Coupon>('/coupons', data),
    updateCoupon: (couponId: string, data: Partial<Coupon>): Promise<AxiosResponse<Coupon>> => apiService.patch<Coupon>(`/coupons/${couponId}`, data),
    updateCouponStatus: (couponId: string, data: { status: string }): Promise<AxiosResponse<Coupon>> => apiService.patch<Coupon>(`/coupons/${couponId}/update-status`, data),
    deleteCoupon: (couponId: string): Promise<AxiosResponse<any>> => apiService.delete<any>(`/coupons/${couponId}`),
};

export default CouponController;